<template>
  <div>
    <div class="ui-pannel">
      <p class="title">{{ $t('title') }}</p>
      <div>
        <p class="topic">{{ $t('total') }}</p>
        <div class="summary">
          <div class="complete">
            <p class="name">
              <i class="el-icon-success"></i>
              <span>{{ $t('total2') }}</span>
            </p>
            <p class="num">{{ myAmount.totalIncome }}</p>
          </div>
          <div class="line"></div>
          <div class="waiting">
            <p class="name">
              <span>{{ $t('wait') }}</span>
            </p>
            <p class="num">{{ myAmount.waitingSettledAmount }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="ui-pannel">
      <p class="title">{{ $t('report') }}</p>
      <div class="content">
        <ul class="tabs">
          <li :class="{ on: tab === 0 }" @click="tab = 0">{{ $t('month') }}</li>
          <li :class="{ on: tab === 1 }" @click="tab = 1">
            {{ $t('detail') }}
          </li>
        </ul>
        <el-table :data="tableData" style="width: 100%" v-show="tab === 0">
          <!-- 序号 -->
          <el-table-column
            type="index"
            width="80"
            label="No."
          ></el-table-column>
          <!-- 月份 -->
          <el-table-column
            label="Month"
            property="studyMonth"
          ></el-table-column>
          <!-- 学生姓名 -->
          <el-table-column
            label="Student Name"
            property="studentName"
            width="140"
          ></el-table-column>
          <!-- 性别 -->
          <!-- <el-table-column label="sex" property="sex">
            <template slot-scope="scope">
              <span v-if="scope.row.studentSex == 1">{{
                $t('common.man')
              }}</span>
              <span v-if="scope.row.studentSex == 2">{{
                $t('common.female')
              }}</span>
            </template>
          </el-table-column> -->
          <!-- 年级 -->
          <el-table-column
            label="School Year"
            property="schoolYear"
            width="140"
          ></el-table-column>
          <!-- 有效课时 -->
          <!-- <el-table-column
            label="EffectiveCourseCount"
            property="effectiveCourseCount"
            width="180"
          ></el-table-column> -->
          <!-- 状态 -->
          <el-table-column label="Status">
            <template slot-scope="scope">
              <span v-if="scope.row.state === 0" class="unsubmit">{{
                $t('pending')
              }}</span>
              <span v-else>{{ $t('done') }}</span>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column label="Action">
            <template slot-scope="scope">
              <a
                v-if="scope.row.state === 0"
                @click="fillReport(scope.row)"
                class="link"
                >{{ $t('write') }}</a
              >
              <router-link :to="{path:'/report',query:{id:scope.row.id}}" class="link" v-else>{{
                $t('view')
              }}</router-link>
            </template>
          </el-table-column>
        </el-table>
        <el-table :data="tableData2" style="width: 100%" v-show="tab === 1">
          <el-table-column
            :label="$t('table.form1')"
            property="settleMonth"
          ></el-table-column>
          <el-table-column
            :label="$t('table.form2')"
            property="completeCourseCount"
          ></el-table-column>
          <el-table-column
            :label="$t('table.form3')"
            property="refundCourseCount"
          ></el-table-column>
          <el-table-column
            :label="$t('table.form4')"
            property="effectiveCourseCount"
          ></el-table-column>
          <el-table-column :label="$t('table.form5')" property="amount">
            <!-- <template slot-scope="scope">
              <span v-if="scope.row.settleState === 1" style="color: red"
                >To be settled</span
              >
              <span v-if="scope.row.settleState === 2">Settled</span>
              <span v-if="scope.row.settleState === 3">Cancel</span>
            </template> -->
          </el-table-column>
          <!-- <el-table-column label="Opt">
            <template slot-scope="scope">
              <a class="link">{{ $t('view') }}</a>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
    </div>
    <comfirm @cancel="cancel" @submit="comfirm" :info="comfirmInfo" />
  </div>
</template>
<script>
import comfirm from '@/components/Comfirm.vue'
import { getMyAmount, getMySettleList, getTeachingChecklist, getMyBankList } from '@/service/teacherApi.js'
export default {
  components: { comfirm },
  data() {
    return {
      tab: 0,
      tableData: [
        { settleMonth: 6, studentName: '王同学', sex: '男', grade: '高二', effectiveCourseCount: 50, state: 1 },
        { settleMonth: 6, studentName: '王同学', sex: '男', grade: '高二', effectiveCourseCount: 50, state: 0 },
      ],
      tableData2: [
        { settleMonth: 7, completeCourseCount: 100, refundCourseCount: 10, effectiveCourseCount: 90, amount: 990, settleState: 2 }
      ],
      comfirmInfo: {
        show: false,
        title: '提示',
        topic: '请完善您的个人资料',
        desc: '银行卡信息未填写，您将无法进行收款',
        cancel: '稍后再说',
        comfirm: '现在就去'
      },
      myAmount: {
        totalIncome: 1,
        canCashAmount: 1
      },
      info1: {
        state: -99,
      },
      haveBankCard: false
    }
  },
  methods: {
    cancel() {
      this.comfirmInfo.show = false
    },
    comfirm() {
      this.$router.push({ path: '/teacherFill', query: { type: 1 } })
    },
    async getMyAmount() {
      let res = await getMyAmount()
      if (res.data.status === 1) {
        this.myAmount = res.data.data
        console.log(this.myAmount);
      }
    },
    async getTeachingChecklist() {
      let res = await getTeachingChecklist({ state: -99 })
      if (res.data.status === 1) {
        this.tableData = res.data.data
      }
    },
    async getMySettleList() {
      let res = await getMySettleList()
      if (res.data.status === 1) {
        this.tableData2 = res.data.data
      }
    },
    fillReport(row) {
      if (this.haveBankCard) {
        this.$router.push({ path: '/report', query: { year: row.studyYear, month: row.studyMonth,id:row.id } })
      } else {
        this.comfirmInfo.show = true
      }
    },
    async getMyBankList() {
      const res = await getMyBankList()
      if (res.data.status === 1) {
        if (res.data.data.length) {
          this.haveBankCard = true
        }
      }
    }
  },
  mounted() {
    this.getMyAmount()
    this.getMySettleList()
    this.getTeachingChecklist()
    this.getMyBankList()
  }
}
</script>
<style lang="scss" scoped>
.topic {
  padding: 40px 50px 0;
  font-size: 21px;
  line-height: 27px;
}
.content {
  padding: 30px 50px 20px;
}
.complete,
.waiting {
  padding: 40px 50px 40px 0;
  text-align: center;
  flex: 1;
  .name {
    font-size: 16px;
    line-height: 24px;
  }
  .num {
    margin-top: 10px;
    font-size: 42px;
    line-height: 55px;
    font-weight: bold;
  }
}
.complete {
  color: #a9c4b1;
  .el-icon-success {
    font-size: 24px;
    vertical-align: top;
    margin-right: 10px;
  }
}
.waiting {
  color: #ffa40e;
  .name:before {
    content: '';
    display: inline-block;
    width: 24px;
    height: 24px;
    background: url(../assets/waiting.png);
    vertical-align: top;
    margin-right: 10px;
  }
}
.summary {
  display: flex;
  .line {
    height: 50px;
    margin-top: 50px;
    border-left: 1px dashed #ddd;
    width: 1px;
  }
}
.tabs {
  display: flex;
  margin-bottom: 30px;
  li {
    margin-right: 10px;
    width: 180px;
    height: 42px;
    line-height: 42px;
    border-radius: 12px 12px 0 0;
    text-align: center;
    background: #a9c4b1;
    color: #fff;
    cursor: pointer;
    &.on {
      background: #002147;
    }
  }
}
.link {
  color: #169bd5;
  &:hover {
    color: lighten(#169bd5, 10%);
    text-decoration: underline;
  }
}
.unsubmit {
  color: red;
}
</style>
<i18n>
{
  "cn": {
    "title": "收入管理",
    "total": "收入总计",
    "total2": "总收入",
    "wait": "待结算",
    "report": "收入报告",
    "month": "每月报告",
    "detail": "结算明细",
    "done": "已提交",
    "pending": "未提交",
    "view": "查看",
    "write": "填写报告",
    "table":{
      "form1":"月份",
      "form2":"完成课程",
      "form3":"退款课程",
      "form4":"有效课程",
      "form5":"分佣金额",
      "form6":"结算状态"
    }
  },
  "TW": {
    "title": "收入管理",
    "total": "收入總計",
    "total2": "總收入",
    "wait": "待結算",
    "report": "收入報告",
    "month": "每月報告",
    "detail": "結算明細",
    "done": "已提交",
    "pending": "未提交",
    "view": "查看",
    "write": "填寫報告"
  },
  "en": {
    "title": "Income management",
    "total": "Total",
    "total2": "Total income",
    "wait": "Pending settlement",
    "report": "Income report",
    "month": "Monthly report",
    "detail": "Summary",
    "done": "Done",
    "pending": "Pending",
    "view": "View",
    "write": "Write a report",
    "table":{
      "form1":"Month",
      "form2":"Completed lessons",
      "form3":"Refund course",
      "form4":"Effective lessons",
      "form5":"Payout amount",
      "form6":"Settlement status"
    }
  }
}
</i18n>